"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var utils_1 = require("./utils");
var types_1 = require("./types");
var constants_1 = require("./constants");
var GROUP_GET_MATCHES_SUCCESS = core_1.default.entities.constants.GROUP_GET_MATCHES_SUCCESS;
var PaginationOptionsRecord = immutable_1.Record({
    hasNext: true,
    minPage: 1,
    currentPage: 1,
    maxPage: 1,
    limitPerPage: 0,
}, 'PaginationOptions');
function makePaginationReducer(_a) {
    var _b;
    var matchesLimitPerPage = _a.matchesLimitPerPage, outrightsLimitPerPage = _a.outrightsLimitPerPage, pollingEdgePage = _a.pollingEdgePage, routes = _a.routes;
    var defaultPaginationOption = {
        limitPerPage: matchesLimitPerPage,
    };
    var mapping = lodash_1.transform(routes, function (acc, i) {
        acc[i] = new PaginationOptionsRecord(defaultPaginationOption);
    }, {});
    var PaginationStateRecord = immutable_1.Record(__assign(__assign({}, mapping), (_b = {}, _b[core_1.App.Routes.OUTRIGHTS_LIST] = {
        offset: 0,
        limit: outrightsLimitPerPage,
    }, _b.direction = types_1.ScrollDirection.DOWN, _b.initialLoad = true, _b.enabled = false, _b.isPollingTurnedOff = false, _b.isVeryTopVisible = false, _b.pollingEdgePage = pollingEdgePage, _b)), 'PaginationState');
    var initialState = new PaginationStateRecord();
    var isPagePaginated = utils_1.isPaginatedPage(routes);
    var paginatedState = initialState;
    if (isPagePaginated) {
        var _c = utils_1.getInitPageNumberAndType(routes), PAGE = _c.PAGE, TYPE = _c.TYPE;
        var validListType = TYPE && initialState.get(TYPE);
        if (validListType) {
            var paginatedType = validListType
                .set('minPage', PAGE > 1 ? PAGE - 1 : 1)
                .set('currentPage', PAGE)
                .set('maxPage', PAGE);
            paginatedState = paginatedState.set(TYPE, paginatedType);
        }
    }
    return function (state, action) {
        if (state === void 0) { state = paginatedState; }
        var groupType = lodash_1.get(action, ['meta', 'group']);
        switch (groupType) {
            case GROUP_GET_MATCHES_SUCCESS: {
                var _a = action.payload, result = _a.result, listType = _a.listType, isPolling = _a.isPolling;
                if (!result.length || !listType || !utils_1.isPaginatedPage(routes)) {
                    return state;
                }
                var listName = utils_1.getPaginatedTypeFromHistory(routes);
                if (!listName)
                    return state;
                var _b = state.get(listName), hasNext = _b.hasNext, maxPage = _b.maxPage;
                var initialLoad = state.initialLoad, enabled = state.enabled, direction = state.direction;
                var isUp = direction === types_1.ScrollDirection.UP;
                /* for previous pages or tournament outrights doing nothing,
                for next pages checking result length */
                var newHasNext = isUp && !isPolling
                    ? hasNext
                    : !(result.length % matchesLimitPerPage);
                /* as long as we've dropped every page beyond polling limit
                in match-list - need to be able to fetch it once more */
                var newMaxPage = isPolling
                    ? maxPage > 1
                        ? pollingEdgePage
                        : 1
                    : maxPage;
                var newDirection = isPolling
                    ? types_1.ScrollDirection.DOWN
                    : direction;
                /* for initial load (with pagination enabled)
                we have to receive two pages at least for non-first page */
                var shouldStayAtInitLoad = enabled &&
                    initialLoad &&
                    maxPage > 1 &&
                    result.length <= matchesLimitPerPage;
                var chunk = state.get(listName);
                var newChunk = chunk
                    .set('hasNext', newHasNext)
                    .set('maxPage', newMaxPage);
                return state
                    .set('initialLoad', shouldStayAtInitLoad)
                    .set(listName, newChunk)
                    .set('direction', newDirection);
            }
            default: {
                break;
            }
        }
        switch (action.type) {
            case constants_1.PAGINATION_ENABLED: {
                return state.set('enabled', true);
            }
            case constants_1.CHANGE_PAGE_NUMBER: {
                var _c = action.payload, page = _c.page, listType = _c.listType;
                if (!page || !listType || !utils_1.isPaginatedPage(routes)) {
                    return state;
                }
                var listName = utils_1.getPaginatedTypeFromHistory(routes);
                if (!listName)
                    return state;
                var currentPage = state[listName].currentPage;
                var _d = utils_1.getNewPaginationPage(__assign(__assign({}, action.payload), { oldPage: currentPage, direction: state.direction })), newPage = _d.newPage, newDirection = _d.newDirection;
                var chunk = state.get(listName);
                var newChunk = chunk.set('currentPage', newPage);
                return state
                    .set('direction', newDirection)
                    .set('isPollingTurnedOff', newPage > pollingEdgePage)
                    .set(listName, newChunk);
            }
            case constants_1.SET_MIN_MAX_PAGES: {
                var listType = action.payload.listType;
                if (!listType || !utils_1.isPaginatedPage(routes)) {
                    return state;
                }
                var listName = utils_1.getPaginatedTypeFromHistory(routes);
                if (!listName)
                    return state;
                var _e = state[listName], minPage = _e.minPage, maxPage = _e.maxPage;
                var direction = state.direction;
                var isUp = direction === types_1.ScrollDirection.UP;
                var newMinPage = isUp && minPage > 1 ? minPage - 1 : minPage;
                var newMaxPage = isUp ? maxPage : maxPage + 1;
                var newChunk = state
                    .get(listName)
                    .set('minPage', newMinPage)
                    .set('maxPage', newMaxPage);
                return state.set(listName, newChunk);
            }
            case constants_1.DROP_STATE: {
                return initialState;
            }
            case constants_1.OPEN_STREAM_AT_VERY_TOP: {
                return state.set('isVeryTopVisible', true);
            }
            default:
                return state;
        }
    };
}
exports.default = makePaginationReducer;
//# sourceMappingURL=reducer.js.map